module.exports = __webpack_public_path__ + "img/safe.5d1c9b59.svg";